import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';

import type { ReservationType } from 'src/features/reservations/types/reservationType';
import type { ListResponseSmartParkAPI } from 'src/types';

interface DTO {
    parkingId?: string;
    reservationType?: string;
}

type ReservationTypeListQueryFnType = typeof getReservationTypeList;

interface UseReservationTypeList extends DTO {
    config?: QueryConfig<ReservationTypeListQueryFnType>;
}

export const getReservationTypeList = ({
    parkingId,
    reservationType,
    ...params
}: DTO): Promise<ListResponseSmartParkAPI<ReservationType>> => {
    return axios.get(`/reservations/${parkingId}/vehicle-stay-reservation-type?reservation_type=${reservationType}`, {
        params,
    });
};

export const useReservationTypeList = ({ config, ...payload }: UseReservationTypeList) => {
    const { reservationType } = payload;
    return useQuery({
        queryKey: ['vehicle-stay-reservation-type', payload],
        queryFn: async () => await getReservationTypeList(payload),
        enabled: !!reservationType,
        ...config,
    });
};
